<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader :title="`${nameLabel} Activity - Department`"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px">
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Role" prop="role">
            <el-select
              v-model="form.role"
              placeholder="Please select Role"
              filterable
              @change="roleChange"
            >
              <el-option
                v-for="(item, idx) in roleOptions"
                :key="idx"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Leader" prop="taId">
            <el-select
              v-model="form.taId"
              placeholder="Please select Leader"
              filterable
              @change="taChange"
            >
              <el-option
                v-for="(item, idx) in taOptions"
                :key="idx"
                :label="item.TAName"
                :value="item.TAID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Team" label-width="55px">
            <el-select
              v-model="form.teamId"
              placeholder="Please select Team"
              filterable
            >
              <el-option
                v-for="(item, idx) in teamOptions"
                :key="idx"
                :label="item.TeamName"
                :value="item.TeamID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option
                v-for="item in yearsOptions"
                :key="item.Year"
                :label="item.Year"
                :value="item.Year"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Month">
            <el-select
              class="month-select"
              ref="monthSelect"
              v-model="form.month"
              placeholder="Please select month"
              multiple
              v-multiple-tip
              @change="monthSelectChange"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Type" prop="type">
            <el-select v-model="form.type" placeholder="Please select type">
              <el-option label="All" value="" />
              <el-option
                label="Content Push / Meeting Push"
                value="ContentMeetingPush"
              />
              <el-option label="Quick Push" value="QuickPush" />
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getTableData()"
            :disabled="queryable"
          >
            Query
          </el-button>
          <el-button
            type="primary"
            icon="iconfont icon-export"
            @click="getTableData(true)"
            :disabled="exportable"
            :loading="exporting"
          >
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="charts" ref="charts" v-role="[2, 6, 8, 10, 12]">
      <div class="chart-row">
        <div class="chart-wrapper">
          <h4>No. Of Push / Hits / Comments</h4>
          <div
            v-show="!noOfPushHitsCommentsChartDataEmpty"
            class="chart"
            ref="noOfPushHitsCommentsChart"
          ></div>
          <div v-show="noOfPushHitsCommentsChartDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <h4>Interaction</h4>
          <div
            v-show="!interactionChartDataEmpty"
            class="chart"
            ref="interactionChart"
          ></div>
          <div v-show="interactionChartDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <h4>Avg. Duration(s)</h4>
          <div
            v-show="!avgPageviewsChartDataEmpty"
            class="chart"
            ref="avgPageviewsChart"
          ></div>
          <div v-show="avgPageviewsChartDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column prop="Department" label="Department" width="125" />
        <el-table-column prop="NoOfPush" label="No. Of Push" min-width="105" />
        <el-table-column prop="NoOfHits" label="No. Of Hits" min-width="115" />
        <el-table-column
          prop="NoOfComments"
          label="No. Of Comments"
          min-width="140"
        />
        <el-table-column
          min-width="115"
          prop="Interactions"
          label="Interaction"
        />
        <el-table-column
          min-width="150"
          prop="AvgPageView"
          label="Avg. Duration(s)"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import * as echarts from "echarts/core";
import { PieChart, BarChart, LineChart, ScatterChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
} from "echarts/components";
import { SVGRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
  PieChart,
  BarChart,
  LineChart,
  ScatterChart,
  SVGRenderer,
]);
import moment from "moment";
import downloadjs from "downloadjs";
import { getDataZoomOptions } from "../../utils/echarts";
import labelMixin from "@/mixins/label-mixin";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "SE-Activity-Department-View",
  mixins: [labelMixin],
  data() {
    return {
      tableLoading: false,
      tableData: [],
      exporting: false,
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        type: "",
      },
      roleList: [],
      taList: [],
      teamList: [],
      otherList: null,
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      queryable: true,
      exportable: true,
      // charts as follow:
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      noOfPushHitsCommentsChart: null,
      noOfPushHitsCommentsChartDataEmpty: false,
      interactionChart: null,
      interactionChartDataEmpty: false,
      avgPageviewsChart: null,
      avgPageviewsChartDataEmpty: false,
      resizeListener: null,
    };
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
      if (this.$options.name === this.$route.meta.title) {
        echarts.throttle(() => {
          this.renderCharts(true);
        }, 200);
      }
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    filterSpan() {
      return this.role === 1 ? 6 : 5;
    },
    isShowCharts() {
      return (
        this.role === RoleCode.Supervisor ||
        this.role === RoleCode.CRPLeader ||
        this.role === RoleCode.CVEOLeader ||
        this.role === RoleCode.SciComLeader ||
        this.role === RoleCode.ClinTransLeader
      );
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
        this.taList.filter(({ RoleName }) => {
          return this.form.role
            ? this.form.role === "MSL"
              ? RoleName === "TALead"
              : RoleName.indexOf(this.form.role) > -1
            : true;
        })
      );
    },
    teamOptions() {
      let options = this.teamList.filter(({ TAID, RoleName }) => {
        return this.form.taId
          ? this.form.taId === TAID
          : RoleName.indexOf(this.form.role) > -1 ||
              (this.form.role === "MSL" &&
                (RoleName === "TALead" || RoleName === "Supervisor"));
      });
      return this.role === 1 || this.role === 4
        ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options)
        : options;
    },
    barWidth() {
      return document.body.clientHeight / 35;
    },
  },
  mounted() {
    if (this.isShowCharts) {
      this.renderCharts();
      this.resizeListener = echarts.throttle(() => {
        if (this.$options.name === this.$route.meta.title) {
          this.onResize();
          this.$nextTick(() => {
            this.renderCharts(true);
          });
        }
      }, 100);
      addResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  beforeDestroy() {
    if (this.isShowCharts && this.resizeListener) {
      removeResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  activated() {
    this.onResize();
    this.$nextTick(() => {
      this.renderCharts(true);
    });
  },
  methods: {
    getDataZoomOptions,
    roleChange() {
      this.form.taId = "";
      this.form.teamId = "";
    },
    taChange() {
      this.form.teamId = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    onResize() {
      if (this.$route.meta.title === this.$options.name) {
        this.noOfPushHitsCommentsChart &&
          this.noOfPushHitsCommentsChart.resize();
        this.interactionChart && this.interactionChart.resize();
        this.avgPageviewsChart && this.avgPageviewsChart.resize();
      }
    },
    hideLoadings() {
      this.noOfPushHitsCommentsChart &&
        this.noOfPushHitsCommentsChart.hideLoading();
      this.interactionChart && this.interactionChart.hideLoading();
      this.avgPageviewsChart && this.avgPageviewsChart.hideLoading();
    },
    showLoadings() {
      this.noOfPushHitsCommentsChart &&
        this.noOfPushHitsCommentsChart.showLoading(this.loadingOption);
      this.interactionChart &&
        this.interactionChart.showLoading(this.loadingOption);
      this.avgPageviewsChart &&
        this.avgPageviewsChart.showLoading(this.loadingOption);
    },
    renderCharts(hideLoading = false) {
      this.renderNoPushHitsCommentsChart();
      this.renderInteractionChart();
      this.renderAvgPageviewsChart();
      if (hideLoading) {
        this.hideLoadings();
      }
    },
    renderNoPushHitsCommentsChart() {
      let chart = this.$refs.noOfPushHitsCommentsChart;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let pushData = [];
      let hitsData = [];
      let commentsData = [];
      this.tableData.forEach((item) => {
        xAxisData.push(item.Department);
        pushData.push({ name: item.Department, value: item.NoOfPush });
        hitsData.push({ name: item.Department, value: item.NoOfHits });
        commentsData.push({ name: item.Department, value: item.NoOfComments });
      });
      this.noOfPushHitsCommentsChartDataEmpty = this.tableData.length === 0;
      const itemStyle = {
        opacity: 0.8,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "rgba(0,0,0,0.1)",
      };
      let option = {
        tooltip: {
          trigger: "axis",
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter(params) {
            let htmlDom =
              params[0].name != " " ? `<h4>${params[0].name}</h4>` : "";
            let isEmpty = false;
            params.forEach((item) => {
              isEmpty = item.value === "";
              if (!isEmpty) {
                htmlDom += `<div class="chart-tooltip"><i style="background:${item.color}"></i><span>${item.seriesName}</span><strong>${item.value}</strong></div>`;
              }
            });
            return htmlDom;
          },
        },
        legend: {
          top: 5,
          data: ["No. Of Push", "No. Of Hits", "No. Of Comments"],
        },
        grid: {
          left: "5%",
          right: "8%",
          top: "20%",
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
                0,
                document.body.clientWidth <= 1024 ? 30 : 40
              )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${
                (index + 1) % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
              }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          min: -1,
          max: xAxisData.length,
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "No. Of Push",
            type: "scatter",
            itemStyle: itemStyle,
            data: pushData,
          },
          {
            name: "No. Of Hits",
            type: "scatter",
            itemStyle: itemStyle,
            data: hitsData,
          },
          {
            name: "No. Of Comments",
            type: "scatter",
            itemStyle: itemStyle,
            data: commentsData,
          },
        ],
      };
      if (!this.noOfPushHitsCommentsChart) {
        this.noOfPushHitsCommentsChart = echarts.init(
          this.$refs.noOfPushHitsCommentsChart,
          null,
          {
            renderer: "svg",
          }
        );
        this.noOfPushHitsCommentsChart.showLoading(this.loadingOption);
      }
      this.noOfPushHitsCommentsChart.setOption(option);
    },
    renderInteractionChart() {
      let chart = this.$refs.interactionChart;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      this.tableData.forEach((item) => {
        xAxisData.push(item.Department);
        valueData.push({ name: item.Department, value: item.Interactions });
      });
      this.interactionChartDataEmpty = this.tableData.length === 0;
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter([params]) {
            return `<h4>${params.name}</h4><div class="chart-tooltip"><i style="background: ${params.color};"></i><span>Interaction</span><strong>${params.value}</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
                0,
                document.body.clientWidth <= 1024 ? 30 : 40
              )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${
                index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
              }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            data: valueData,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: "#3ba272",
            },
          },
        ],
      };
      if (!this.interactionChart) {
        this.interactionChart = echarts.init(
          this.$refs.interactionChart,
          null,
          {
            renderer: "svg",
          }
        );
        this.interactionChart.showLoading(this.loadingOption);
      }
      this.interactionChart.setOption(option);
    },
    renderAvgPageviewsChart() {
      let chart = this.$refs.avgPageviewsChart;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      this.tableData.forEach((item) => {
        xAxisData.push(item.Department);
        valueData.push({ name: item.Department, value: item.AvgPageView });
      });
      this.avgPageviewsChartDataEmpty = this.tableData.length === 0;
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter([params]) {
            return `<h4>${params.name}</h4><div class="chart-tooltip"><i style="background: ${params.color};"></i><span>Avg. Duration(s)</span><strong>${params.value}</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
                0,
                document.body.clientWidth <= 1024 ? 30 : 40
              )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${
                index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
              }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            data: valueData,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: "#ee6666",
            },
          },
        ],
      };
      if (!this.avgPageviewsChart) {
        this.avgPageviewsChart = echarts.init(
          this.$refs.avgPageviewsChart,
          null,
          {
            renderer: "svg",
          }
        );
        this.avgPageviewsChart.showLoading(this.loadingOption);
      }
      this.avgPageviewsChart.setOption(option);
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      if (this.isShowCharts && !exportable) {
        this.noOfPushHitsCommentsChartDataEmpty = false;
        this.interactionChartDataEmpty = false;
        this.avgPageviewsChartDataEmpty = false;
        this.$nextTick(() => {
          this.onResize();
        });
        this.showLoadings();
      }
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
          mlName: this.mlName,
        });
      }
      this.axios
        .get(`analytics/seDepartment`, {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableData = data;
              this.tableLoading = false;
              this.renderCharts(true);
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get(`analytics/otherList`),
        this.axios.get(`analytics/roleList`),
      ]).then((res) => {
        this.getTAList(res[0]);
        this.getTeamList(res[1]);
        this.getOtherList(res[2]);
        this.getRoleList(res[3]);
        this.getTableData();
        this.queryable = false;
        this.exportable = false;
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (
          this.role === RoleCode.Supervisor ||
          this.role === RoleCode.TALead
        ) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(
            ({ value }) => roleName.indexOf(value) > -1
          ) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        this.taList = data;
        if (this.role === 4) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (
          this.role == RoleCode.Supervisor ||
          this.role == RoleCode.CRPLeader ||
          this.role == RoleCode.CVEOLeader ||
          this.role == RoleCode.SciComLeader ||
          this.role == RoleCode.ClinTransLeader
        ) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;
  .el-form-item {
    margin-bottom: 10px !important;
    .el-select {
      width: 100%;
    }
  }
  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>
